module.exports = __webpack_public_path__ + "img/peoployed-254.e56c0c3c.png";